/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupTypeResponseModel } from './LookupTypeResponseModel';
import {
    LookupTypeResponseModelFromJSON,
    LookupTypeResponseModelFromJSONTyped,
    LookupTypeResponseModelToJSON,
} from './LookupTypeResponseModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfListOfLookupTypeResponseModel
 */
export interface ResultOfListOfLookupTypeResponseModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfListOfLookupTypeResponseModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfLookupTypeResponseModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfLookupTypeResponseModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfLookupTypeResponseModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfLookupTypeResponseModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfListOfLookupTypeResponseModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfListOfLookupTypeResponseModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<LookupTypeResponseModel>}
     * @memberof ResultOfListOfLookupTypeResponseModel
     */
    data?: Array<LookupTypeResponseModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfLookupTypeResponseModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfListOfLookupTypeResponseModel interface.
 */
export function instanceOfResultOfListOfLookupTypeResponseModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfListOfLookupTypeResponseModelFromJSON(json: any): ResultOfListOfLookupTypeResponseModel {
    return ResultOfListOfLookupTypeResponseModelFromJSONTyped(json, false);
}

export function ResultOfListOfLookupTypeResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfListOfLookupTypeResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(LookupTypeResponseModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfListOfLookupTypeResponseModelToJSON(value?: ResultOfListOfLookupTypeResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(LookupTypeResponseModelToJSON)),
        'Count': value.count,
    };
}

